import { Sofa, Leaf, ChevronRight } from "lucide-react";
import { SERVICIOS_INFO } from "@/mock";

const ICONS = { Sofa, Leaf };

export default function Step0Service({ data, update, onNext }) {
  return (
    <div>
      <h2 className="font-heading font-bold text-2xl text-municipal mb-2">¿Qué tipo de recogida necesitas?</h2>
      <p className="text-gray-500 mb-8">Selecciona el servicio para conocer los días disponibles.</p>
      <div className="grid sm:grid-cols-2 gap-6">
        {Object.values(SERVICIOS_INFO).map((s) => {
          const Icon = ICONS[s.icon];
          const selected = data.tipo_servicio === s.id;
          return (
            <button
              key={s.id}
              type="button"
              onClick={() => {
                update({ tipo_servicio: s.id });
                onNext();
              }}
              data-testid={`wizard-step0-${s.id}`}
              className={`text-left p-6 rounded-2xl border-2 transition-all hover:shadow-lg ${
                selected ? "border-municipal bg-municipal/5" : "border-gray-200 bg-white"
              }`}
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                style={{ backgroundColor: s.color }}
              >
                <Icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-heading font-semibold text-lg text-municipal mb-1">{s.nombre}</h3>
              <p className="text-sm text-gray-500 mb-3">{s.descripcion}</p>
              <span className="inline-flex items-center text-sm font-medium text-dorado">
                {s.dias} <ChevronRight className="w-4 h-4 ml-1" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
